/**
 * useServiceAccounts Hook
 *
 * React Query hook for fetching service accounts list.
 */

import { useQuery } from '@tanstack/react-query';
import { serviceAccountService } from '../../../api/service-account.service';
import type { ServiceAccountSanitized, ServiceAccountListQuery } from '../../../types/service-account.types';

export const SERVICE_ACCOUNTS_QUERY_KEY = 'serviceAccounts';

export function useServiceAccounts(tenantId: string, query?: ServiceAccountListQuery) {
  return useQuery<ServiceAccountSanitized[], Error>({
    queryKey: [SERVICE_ACCOUNTS_QUERY_KEY, tenantId, query],
    queryFn: () => serviceAccountService.listServiceAccounts(tenantId, query),
    enabled: !!tenantId,
    staleTime: 30000,
  });
}
